import { Box, Divider } from "@mui/material";
import type { FC } from "react";
import type { PortfolioListReportingSummaryResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { PortfolioListItemRedesign } from "web_myplann/Portfolio/Components/Redesign/PortfolioListItemRedesign";
import type { CategoryItem } from "web_myplann/Portfolio/Types/portfolioCategory";

type Props = {
	items: CategoryItem[];
	summaryData: PortfolioListReportingSummaryResponseDTO[] | undefined;
};

export const PortfolioFlatList: FC<Props> = ({ items, summaryData }) => (
	<Box bgcolor="background.paper">
		{items.map((item, index) => {
			const isLastItem = index === items.length - 1;

			return (
				<Box key={`${item.kind}-${item.data.id}`}>
					<PortfolioListItemRedesign item={item} summaryData={summaryData} />
					{!isLastItem && <Divider redesigned />}
				</Box>
			);
		})}
	</Box>
);
